





















































import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import QuestionApi from '@/api/question/index.ts'

@Component({
  components: {}
})
export default class AnswerQuestionDetail extends AbpBase {
  questionDetail: any = {}
  questions = []

  alphabetList: any[] = []

  columns = [
    {
      title: '选项',
      slot: 'text'
    }
  ]

  created() {
    this.upperCaseChars()
    this.getQuestionnaire()
  }

  /**
   * 生成字母列表 A-Z
   */
  upperCaseChars() {
    //生成大写字母，A的Unicode值为65
    this.alphabetList = []
    for (var i = 65; i < 91; i++) {
      this.alphabetList.push(String.fromCharCode(i))
    }
  }

  /**
   * 获取答卷详情
   */
  getQuestionnaire() {
    let id = this.$route.query['id']
    if (id) {
      QuestionApi.getQuestionnaireAnswer(id.toString())
        .then(res => {
          if (res.data) {
            this.questionDetail = res.data
            let { answers = [] } = res.data
            answers = answers || []
            let resArr = answers.filter(element => {
              if (element.type === 2) {
                return Boolean(element.value)
              } else if (element.type === 0 || element.type === 1) {
                return element.optIndex.length
              } else {
                return true
              }
            })
            this.questions = resArr
          }
        })
    }
  }
  rowClassName(row, index) {
    if (row.optIndex.includes(index)) {
      return 'demo-table-info-row'
    }
    return ''
  }
}
